import React from "react";
import { useNavigate } from "react-router-dom";
import { FiPlus } from "react-icons/fi";

import Button from "../../../../components/Button";

export default function NewPurchaseRequirementButton() {
  const navigate = useNavigate();

  const onClick = React.useCallback(() => {

    window.gtag("event", "newPurchaseRequirement", {
      startedAt: new Date().toString()
    });

    navigate("new-opportunity/information");
  }, []);

  return (
    <Button
      color="primary"
      variant="contained"
      leftLabel={FiPlus as unknown as string}
      onClick={onClick}
      label="New Purchase Opportunity"
    />
  );
}
